const formatQuantity = value => $.fn.dataTable.render.number(' ', ',', 0).display(value || 0);
const formatMoney = value => $.fn.dataTable.render.number(' ', ',', 2).display(value || 0) + ' ₽';

function updateNotes($table) {
    $table.find('tbody .balance-item-note').each(function () {
        const $note = $(this);
        const text = $note.find('.balance-item-note-text')[0];
        const button = $note.find('.balance-item-note-toggle')[0];
        if (!text || !button) return;

        const overflows = text.scrollHeight > text.clientHeight + 1;
        button.hidden = !overflows && !$note.hasClass('is-expanded');
    });
}

module.exports = function initStockBalanceTable($table, registry) {
    const statusColumn = registry ? 4 : 3;
    const propertyColumn = registry ? 3 : null;
    const valuationColumn = registry ? 6 : 5;
    const availabilityColumn = registry ? 12 : 11;
    const $wrapper = $table.closest('.balance-table-wrapper');

    const columns = [
        window.dataTableDetailsControlColumn(),
        { data: 'item', className: 'all balance-item-cell', responsivePriority: 2, orderable: true },
        { data: 'quantity_value', className: 'all text-nowrap balance-quantity-cell', render: function (data, type, row) { return type === 'display' ? row.quantity : data; } }
    ];
    if (registry) {
        columns.push({ data: 'property', className: 'balance-property-cell', responsivePriority: 6 });
    }
    columns.push(
        { data: 'status', className: 'balance-status-cell', responsivePriority: 3 },
        { data: 'original_cost_value', className: 'balance-cost-cell', responsivePriority: 4, render: function (data, type, row) { return type === 'display' ? row.cost : data; } },
        { data: 'valuation', className: 'balance-valuation-cell', responsivePriority: 50, render: function (data, type, row) { return type === 'display' ? data : row.valuation_label; } },
        { data: 'warranty', className: 'balance-warranty-cell', orderable: false, responsivePriority: 80 },
        { data: 'contract_inventory', className: 'balance-inventory-cell', responsivePriority: 90 },
        { data: 'provenance', className: 'none', orderable: false },
        { data: 'unrecognized_cost_detail', className: 'none', orderable: false },
        { data: 'valuation_label', className: 'none', orderable: false },
        { data: 'availability_detail', className: 'none', orderable: false },
        { data: 'actions', className: 'all text-nowrap text-center table-col-actions', orderable: false, searchable: false }
    );

    const dt = $table.DataTable({
        processing: true,
        serverSide: true,
        pageLength: 25,
        searchDelay: 350,
        order: registry ? [[1, 'asc']] : [],
        lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
        ajax: registry ? {
            url: $table.data('url'),
            headers: { 'Accept': 'application/json' },
            data: function (d) {
                $('#stock-balances-filters').serializeArray().forEach(function (item) {
                    if (item.value === '') return;
                    if (d[item.name] === undefined) {
                        d[item.name] = item.value;
                    } else {
                        d[item.name] = [].concat(d[item.name], item.value);
                    }
                });
            }
        } : $table.data('url'),
        columns: columns,
        language: window.dataTablesRussianLanguage,
        responsive: {
            details: {
                type: 'column',
                target: 0,
                renderer: function (api, rowIndex, cells) {
                    const row = api.row(rowIndex).data();
                    const items = cells.filter(cell => cell.hidden && cell.columnIndex !== valuationColumn && (cell.columnIndex !== availabilityColumn || row.blocked_quantity > 0)).map(function (cell) {
                        const title = $('<span>').html(cell.title).text().trim();
                        return '<li><span class="dtr-title">' + $('<span>').text(title).html() + '</span><span class="dtr-data">' + cell.data + '</span></li>';
                    });
                    return items.length ? $('<ul class="dtr-details">').html(items.join('')) : false;
                }
            }
        },
        drawCallback: function () {
            const api = this.api();
            const json = api.ajax.json() || {};
            updateNotes($table);
            $table.find('tbody .balance-quantity-warning').tooltip({ placement: 'auto' });

            if (!registry) return;

            const filtered = json.recordsFiltered !== undefined ? json.recordsFiltered : (json.recordsTotal || 0);
            const $emptyState = $('#stock-balances-empty-state');
            $(api.table().container()).toggle((json.recordsTotal || 0) !== 0);
            $emptyState.toggle((json.recordsTotal || 0) === 0);

            const $totals = $('#stock-balances-totals');
            $totals.prop('hidden', filtered === 0);
            if (!filtered) return;

            const pageRows = api.rows({ page: 'current' }).data().toArray();
            const sum = field => pageRows.reduce((total, row) => total + (Number(row[field]) || 0), 0);
            $totals.find('[data-balance-totals="page"]').text('Количество: ' + formatQuantity(sum('quantity_value')) + '; первоначальная стоимость: ' + formatMoney(sum('original_cost_value')) + '; не признано: ' + formatMoney(sum('unrecognized_cost_value')));
            $totals.find('[data-balance-totals="filtered"]').text('Количество: ' + formatQuantity(json.sumQuantity) + '; первоначальная стоимость: ' + formatMoney(json.sumOriginalCost) + '; не признано: ' + formatMoney(json.sumUnrecognizedCost));
        }
    });

    window.enhanceResponsiveDataTableDetails($table, dt);

    function syncColumns() {
        const visible = dt.columns().responsiveHidden().toArray();
        $table.toggleClass('balance-status-in-item', visible[statusColumn] === false);
        if (propertyColumn !== null) {
            $table.toggleClass('balance-property-in-item', visible[propertyColumn] === false);
        }
        updateNotes($table);
    }

    $table.on('responsive-resize.dt', syncColumns);
    $table.on('draw.dt', syncColumns);
    $table.on('click', '.balance-item-note-toggle', function () {
        const $note = $(this).closest('.balance-item-note');
        const expanded = $note.toggleClass('is-expanded').hasClass('is-expanded');
        $(this).attr('aria-expanded', expanded).text(expanded ? 'Свернуть' : 'Показать полностью');
        updateNotes($table);
    });
    $table.on('click', 'thead .balance-help', function (event) { event.stopPropagation(); });

    function adjustToWidth() {
        $wrapper.toggleClass('balance-table-compact', $wrapper[0].clientWidth < 560);
        dt.columns.adjust();
        dt.responsive.recalc();
        syncColumns();
    }

    // Responsive calculates widths against the table's parent, including when a panel changes size.
    if (window.ResizeObserver) {
        let previousWidth = $wrapper[0].clientWidth;
        const observer = new ResizeObserver(function () {
            const width = $wrapper[0].clientWidth;
            if (width === previousWidth) return;
            previousWidth = width;
            adjustToWidth();
        });
        observer.observe($wrapper[0]);
        $table.on('destroy.dt', function () { observer.disconnect(); });
    }
    setTimeout(adjustToWidth, 0);

    return dt;
};
